import myClaimsIcon from "../assets/myClaimsIcon.svg";
import carIcon from "../assets/car.svg";
import roadsideAssistanceIcon from "../assets/roadsideAssistanceIcon.svg";
import paymentHistoryIcon from "../assets/svgs/paymentHistory.svg";
import starIcon from "../assets/star.svg";
import learnAboutIcon from "../assets/svgs/learnAboutInsuranceIcon.svg";
import viewAllArrow from "../assets/viewAllArrow.svg";
import leftArrow from "../assets/left_arrow.svg";
import filter from "../assets/filter.svg";
import searchIcon from "../assets/search.svg";
import updownArrow from "../assets/upDownArrow.svg";
import closeImage from "../assets/x-circle.svg";
import ellipsis from "../assets/vertical_ellipse.svg";
import downArrow from "../assets/downArrow.svg";
import activeClaim from "../assets/activeclaims.svg";
import pastClaim from "../assets/pastClaims.svg";
import carSmall from "../assets/carSmall.svg";

export const SETTINGS_AND_PREFERENCES = "Settings and Preferences";
export const LANGUAGE = "Language";
export const SELECT_LANGUAGE = "Select Language you are comfortable with";
export const NOTIFICATIONS = "Notifications";
export const LET_US_KNOW =
  "Let us know how and when you would like to be notified";
export const PROFILE_DETAILS_HEADING = "Profile Details";

export const customerPages = [
  "policyDetails",
  "dashboard",
  "paymentSuccess",
  "paymentError",
  "profile",
  "service-requests",
  "policies",
  "claims",
  "newcustomerDashboard",
  "voiceForms",
  "insure-assist",
];
export const adminPages = [
  "dashboard",
  "forms",
  "lookup",
  "uiconfiguration",
  "features",
  "login",
  "secretkeys",
  "usermanagement",
  "loginreports",
  "cms",
  "conversation-analysis",
  "insure-assist-performance",
  "communication-templates",
  "prompt-management",
  "password-configuration",
  "roles-permissions",
  "customer-analytics",
  "settings",
  "register",
  "reset-password",
];
export const agentPages = [
  "login",
  "dashboard",
  "mytasks",
  "paymentSchedule",
  "documentListing",
  "policyListing",
  "policyDetails",
  "customerListing",
  "newTask",
  "commissionStatements",
  "monthlyStatement",
  "config",
  "customerDetails",
  "claimTracking",
  "market",
  "documentDetails",
  "hierarchy",
  "underwriter",
];
export const policiesHeading = "Here Is Your List Of Policies";
export const quickReferences = "Quick References For You";
export const footerLeftText = "© 2025 Smart IMS. All rights reserved.";
export const termsAndService = "Terms of Service";
export const privatePolicy = "Privacy Policy";
export const viewAll = "View All";
export const trackYourClaim = "Track Your Claim";
export const renewalAmount = "Renewal Amount :";
export const renewNow = "Renew Now";
export const duesDate = "Due Date :";
export const terms = " : Tax and Fee may apply.";
export const newClaim = "New Claim";
export const paymentHistory = "Payment History";
export const roadSideAssistance = "Roadside Assistance";
export const learnAbout = "Learn about Insurance";
export const name = "Mathew";
export const viewPast = "View Past Claims";
export const attentionText = "Alerts";
export const breadcrumbText = "12AW1145G057 |  Auto_Garage101";
export const leftArrowText = "Navigate Before Icon";
export const policyDetailsHead = "Policy";
export const vehicleName = "Elena Rodriguez";
export const numberOfVEchiles = "2";
export const billingHead = "Invoice";
export const price = "821.00";
export const dueDate = "01 Mar’24";
export const premiumHead = "Premium";
export const annaulPrice = "2917.00";
export const term = "1 Year";
export const vaild = "02 Mar‘23 - 01 Mar’24";
export const status = "Active";
export const dueOn = "Due on";
export const fileClaim = "File a claim";
export const download = "Download";
export const addWallet = "Add to wallet";
export const fileAClaim = "File a Claim";
export const clickToUpload = "Click to upload";
export const claimSubmitted = "Claim Submitted";
export const referenceNumber = "Please find your claim reference number ";
export const contactAgent = "Contact your Agent for further process";
export const agentDetails = "Agent Details";
export const businessAddress = "Business Address";
export const loginMessage = "Welcome, please login to continue";
export const loginName = "Mathew Thomas";
export const loginPassword = "Mathew Thomas";
export const signedIn = "Keep me signed in.";
export const forgotPassword = "Forgot password?";
export const login = "Login";
export const register = "Register here";
export const account = "Don't have an account?";
export const residential = "Residential Address";
export const contact = "Contact Details";
export const selectPayment = "Select Payment Method";
export const creditCard = "Credit Card";
export const debitCard = "Debit Card";
export const paymentmethod = "Payment Method";
export const cancel = "Cancel";
export const save = "Save";
export const activeClaims = "Active Claims";
export const pastClaims = "Past Claims";
export const turnOnAutoPayment = "Turn-on Auto Payment";
export const changePassword = "Change Password";
export const createNew = "Hi, kindly create a new password.";
export const setNewPassword =
  "Your new password must be different to your previously three used passwords";
export const passwordMustContain = "Password must contain";
export const currentPassword = "Current Password";
export const confirmPassword = "Confirm Password";
export const newPassword = "New Password";
export const atleastEight = "At least 8 characters.";
export const oneUpperCase = "At least 1 UPPERCASE letter (A-Z)";
export const oneLowerCase = "At least 1 lowercase letter (a-z)";
export const oneNumber = "At least 1 number (0-9)";
export const complete = "Complete";
export const incidentType = "Incident Type";
export const editProfile = "Edit Profile";
export const enterNewPassword = "Forget Password";
export const phoneNumber = "Phone Number";
export const city = "City";
export const state = "State";
export const country = "Country";
export const policyTypeLabel = "Policy Type";
export const policyHash = "Policy #";
export const fileAClaimVehicle = "Vehicle";
export const incidentLocation = "Incident Location";
export const incidentDescription = "Incident Description";
export const names = "Name";
export const contactNumber = "Contact Number";
export const bankName = "Bank Name";
export const accountNumber = "Account Number";
export const address = "Address";
export const enableAll = "Enable All";
export const language = "Language";

export const policyNumber = "Policy Number";
export const policyStatus = "Status";
export const policyPremium = "Premium:";
export const policyTerm = "Term:";
export const policyDueDate = "Due Date:";
export const days = "Days";
export const daysIn = "in";
export const password = "Password";
export const payoutAmount = "Payout Amount:";
export const claimNumber = "Claim Number:";
export const closureReason = "Closure Reason:";
export const filterText = "Filter";
export const billingAmount = " Billing amount";
export const billingDate = "Billing Date";
export const paidAmount = "Paid Amount";
export const paidOn = "Paid on";
export const coveragesLimits = "Coverage and Limits";
export const discounts = "Discounts";
export const coverages = "Coverages";
export const limits = "Limit";
export const typ = "Type";

export const MYCLAIM_ICON = myClaimsIcon;
export const CAR_ICON = carIcon;
export const STAR_ICON = starIcon;
export const PAYMENT_ICON = paymentHistoryIcon;
export const ASSISTANCE_ICON = roadsideAssistanceIcon;
export const LEARN_ICON = learnAboutIcon;
export const VIEW_ARROW = viewAllArrow;
export const LEFT_ARROW = leftArrow;
export const FILTER = filter;
export const SEARCH = searchIcon;
export const UP_DOWN_ARROW = updownArrow;
export const ELLIPSIS = ellipsis;
export const CLOSE = closeImage;
export const DOWN_ARROW = downArrow;
export const ACTIVE_CLAIM = activeClaim;
export const PAST_CLAIM = pastClaim;
export const CAR_ICON_SMALL = carSmall;
export const vehicles = "Vehicles";
export const drivers = "Drivers";
export const vehicle = "Vehicles";
export const driver = "Drivers";
export const imageNotFound = "image not found";
export const policyTabsList = [
  //ADMIN FEATURE CODES FOR PROPERTY TAB
  {
    label: "Vehicles & Drivers",
    lobCode: "PA",
    code: "lob_pa_policies_vehicles_and_drivers",
  },
  { label: "Dwelling", lobCode: "HO", code: "lob_ho_policies_dwelling" },
  {
    label: "Related Policies",
    lobCode: "PU",
    code: "lob_pu_policies_related_policies",
  },
 //{ label: "Property", lobCode: "BOP", code: "lob_bop_policies_property_tab" },
  { label: "Risk & Coverage", lobCode: "BOP", code: "lob_bop_policies_risks_coverages" },
  { label: "Risk & Coverage", lobCode: "FO", code: "lob_fo_policies_risk_coverages" },
  //{ label: "Property", lobCode: "FO", code: "lob_fo_policies_property_tab" },
  //ADMIN FEATURE CODES FOR POLICY COVERAGES TAB
  { label: "Coverages", lobCode: "PA", code: "lob_pa_policies_coverages" },
  { label: "Coverages", lobCode: "HO", code: "lob_ho_policies_coverages" },
  { label: "Coverages", lobCode: "PU", code: "lob_pu_policies_coverages" },

  // {
  //   label: "Liability",
  //   lobCode: "BOP",
  //   code: "lob_bop_policies_liability_tab",
  // },
  //ADMIN FEATURE CODES FOR POLICY DOCUMENTS
  {
    label: "Documents",
    lobCode: "PA",
    code: "lob_pa_policies_policy_documents",
  },
  {
    label: "Documents",
    lobCode: "HO",
    code: "lob_ho_policies_policy_documents",
  },
  {
    label: "Documents",
    lobCode: "PU",
    code: "lob_pu_policies_policy_documents",
  },
  {
    label: "Documents",
    lobCode: "BOP",
    code: "lob_bop_policies_policy_documents",
  },
  {
    label: "Documents",
    lobCode: "FO",
    code: "lob_fo_policies_policy_documents",
  },

  { label: "Lienholder", lobCode: "PA", code: "lob_pa_policies_lienholders" },
  { label: "Mortgagee", lobCode: "HO", code: "lob_ho_policies_mortgagee" },

  //ADMIN FEATURE CODES FOR BILLING TAB
  { label: "Billing", lobCode: "PA", code: "lob_pa_billing_billing_tab" },
  { label: "Billing", lobCode: "HO", code: "lob_ho_billing_billing_tab" },
  { label: "Billing", lobCode: "PU", code: "lob_pu_billing_billing_tab" },
  { label: "Billing", lobCode: "BOP", code: "lob_bop_billing_billing_tab" },
  { label: "Billing", lobCode: "FO", code: "lob_fo_billing_billing_tab" },

  //ADMIN FEATURE CODES FOR CLAIMS TAB
  { label: "Claims", lobCode: "PA", code: "lob_pa_claims_claims_tab" },
  { label: "Claims", lobCode: "HO", code: "lob_ho_claims_claims_tab" },
  { label: "Claims", lobCode: "PU", code: "lob_pu_claims_claims_tab" },
  { label: "Claims", lobCode: "BOP", code: "lob_bop_claims_claims_tab" },
  { label: "Claims", lobCode: "FO", code: "lob_fo_claims_claims_tab" },

  //ADMIN FEATURE CODES FOR ACTIVITY TAB
  { label: "Activity", lobCode: "PA", code: "lob_pa_policies_activity" },
  { label: "Activity", lobCode: "HO", code: "lob_ho_policies_activity" },
  { label: "Activity", lobCode: "PU", code: "lob_pu_policies_activity" },
  { label: "Activity", lobCode: "BOP", code: "lob_bop_policies_activity" },
  { label: "Activity", lobCode: "FO", code: "lob_fo_policies_activity" },

  //ADMIN FEATURE CODES FOR OTHER TABS & FUNCTIONALITIES
  { label: "Notes", code: "agent_notes_tab" },
];

export const youtubeVideoUrl = "https://www.youtube.com/embed/JFjOpajKeOw";
export const videoUrl =
  "http://3.20.231.65/videos/Navigating%20Auto%20Liability%20Limits%20Your%20Road%20to%20Financial%20Security.mp4";

export const dateFormat = "MMM DD, YYYY";

export const countryCurrency = {
  us: {
    name: "en-US",
    currency: "USD",
  },
};

export const rowsPerPageOptions = [5, 10, 25];
export const defaultDuration = "7";

//** Admin */
export const lookupFormFields = [
  { name: "name", label: "Name" },
  { name: "label", label: "Label" },
  { name: "code", label: "Code" },
];
export const defaultUiSetting = {
  iconColor: "rgb(255 192 112)",
};
export const includesCoverages = [
  "CovA",
  "CovB",
  "CovC",
  "CovD",
  "CovE",
  "CovF",
];

export const featuresCodes = {
  //ADMIN FEATURE CODES FOR FILE A CLAIM
  "File A Claim": {
    PA: ["lob_pa_claims_new_claim"],
    HO: ["lob_ho_claims_new_claim"],
    PU: ["lob_pu_claims_new_claim"],
    BOP: ["lob_bop_claims_new_claim"],
    FO: ["lob_fo_claims_new_claim"],
  },

  //ADMIN FEATURE CODES CHANGE POLICY SINGLE SCREEN
  "Change Policy Single Screen": {
    PA: ["lob_pa_policies_change_policy_single_screen"],
    HO: ["lob_ho_policies_change_policy_single_screen"],
    PU: ["lob_pu_policies_change_policy_single_screen"],
    BOP: ["lob_bop_policies_change_policy_single_screen"],
    FO:  ["lob_fo_policies_change_policy_single_screen"],
  },

  //ADMIN FEATURE CODES FOR PAYMENTS
  Pay: {
    PA: ["lob_pa_billing_payments"],
    HO: ["lob_ho_billing_payments"],
    PU: ["lob_pu_billing_payments"],
    BOP: ["lob_bop_billing_payments"],
    FO: ["lob_fo_billing_payments"],
  },

  //ADMIN FEATURE CODES FOR VIEW POLICY
  "View Policy": {
    PA: ["lob_pa_policies_view_policy"],
    HO: ["lob_ho_policies_view_policy"],
    PU: ["lob_pu_policies_view_policy"],
    BOP: ["lob_bop_policies_view_policy"],
    FO: ["lob_fo_policies_view_policy"],
  },

  //ADMIN FEATURE CODES FOR TRACK YOUR CLAIM
  "Track Your Claim": {
    PA: ["lob_pa_claims_track_claim"],
    HO: ["lob_ho_claims_track_claim"],
    PU: ["lob_pu_claims_track_claim"],
    BOP: ["lob_bop_claims_track_claim"],
    FO: ["lob_fo_claims_track_claim"],
  },

  //ADMIN FEATURE CODES FOR VIEW CLAIM DOCUMENTS
  Documents: {
    PA: ["lob_pa_claims_claim_documents"],
    HO: ["lob_ho_claims_claim_documents"],
    PU: ["lob_pu_claims_claim_documents"],
    BOP: ["lob_bop_claims_claim_documents"],
    FO: ["lob_fo_claims_claim_documents"],
  },

  //ADMIN FEATURE CODES FOR OTHER FUNCTIONALITIES
  "Download ID": {
    PA: ["lob_pa_policies_insurance_id"],
  },
  "Roadside Assistance": {
    PA: ["roadside_assistance"],
  },
  "Cancel Policy": {
    PA: ["lob_pa_policies_cancel_policy"],
  },
};
export const drawerWidth = 270;
export const headerHeight = 80;

export const LOADING_REDUCER_TYPES = [
  "userAuth/login",
  "agentAuth/agentLogin",
  "adminAuth/adminLogin",
  "uiSettings/getUiSettings",
  "claims/PostFileAClaim",
];

export const ALL_AGENT_ROLE_CODES = ["Producer", "Agent", "Agency", "Group"];

export const policyCardsData = [
  {
    title: "Update Vehicles",
    lobCode: "PA",
    checkboxList: [
      {
        label: "Add Vehicle",
        featureCode: "lob_pa_policies_add_vehicle",
      },
      {
        label: "Remove Vehicle",
        featureCode: "lob_pa_policies_delete_vehicle",
      },
    ],
  },
  {
    title: "Update Drivers",
    lobCode: "PA",
    checkboxList: [
      {
        label: "Add Driver",
        featureCode: "lob_pa_policies_add_driver",
      },
      {
        label: "Remove Driver",
        featureCode: "lob_pa_policies_delete_driver",
      },
      {
        label: "Edit Driver",
        featureCode: "lob_pa_policies_edit_driver",
      },
    ],
  },
  {
    title: "Update Lienholder",
    lobCode: "PA",
    checkboxList: [
      {
        label: "Add Lienholder",
        featureCode: "lob_pa_policies_add_lienholder",
      },
    ],
  },
  {
    title: "Update Coverages",
    lobCode: "PA",
    checkboxList: [
      {
        label: "Add Coverages",
        featureCode: "lob_pa_policies_add_coverages",
      },
      {
        label: "Remove Coverages",
        featureCode: "lob_pa_policies_remove_coverages",
      },
      {
        label: "Edit Coverages",
        featureCode: "lob_pa_update_edit_coverages",
      },
    ],
  },
  {
    title: "Change Address",
    lobCode: "PA",
    checkboxList: [
      {
        label: "Change Garage Location",
        featureCode: "lob_pa_policies_update_garage_location",
      },
      {
        label: "Change Mailing/Billing Address",
        featureCode: "lob_pa_policies_change_mailing_address",
      },
    ],
  },
  {
    title: "Change Address",
    lobCode: "HO",
    checkboxList: [
      {
        label: "Change Mailing/Billing Address",
        featureCode: "lob_ho_policies_change_mailing_address",
      },
    ],
  },
  {
    title: "Update Coverages",
    lobCode: "HO",
    checkboxList: [
      {
        label: "Add Coverages",
        featureCode: "lob_ho_policies_add_coverages",
      },
      {
        label: "Remove Coverages",
        featureCode: "lob_ho_policies_remove_coverages",
      },
      {
        label: "Edit Coverages",
        featureCode: "lob_ho_update_edit_coverages",
      },
    ],
  },
  {
    title: "Change Address",
    lobCode: "PU",
    checkboxList: [
      {
        label: "Change Mailing/Billing Address",
        featureCode: "lob_ho_policies_change_mailing_address",
      },
    ],
  },
  {
    title: "Update Coverages",
    lobCode: "PU",
    checkboxList: [
      {
        label: "Add Coverages",
        featureCode: "lob_ho_policies_add_coverages",
      },
      {
        label: "Remove Coverages",
        featureCode: "lob_ho_policies_remove_coverages",
      },
      {
        label: "Edit Coverages",
        featureCode: "lob_ho_update_edit_coverages",
      },
    ],
  },
  {
    title: "Property Details",
    lobCode: "BOP",
    checkboxList: [
      {
        label: "Update Property Details",
        featureCode: "lob_bop_policies_update_property_details",
      },
    ],
  },
  {
    title: "Building Safety Features",
    lobCode: "BOP",
    checkboxList: [
      {
        label: "Update Building Safety Features",
        featureCode: "lob_bop_policies_update_building_safety_features",
      },
    ],
  },
  {
    title: "Usage & Occupancy",
    lobCode: "BOP",
    checkboxList: [
      {
        label: "Update Usage & Occupancy",
        featureCode: "lob_bop_policies_update_usage_and_occupancy",
      },
    ],
  },
  {
    title: "Dwelling Details",
    lobCode: "FO",
    checkboxList: [
      {
        label: "Update Dwelling Details",
        featureCode: "lob_fo_policies_update_dwelling_details",
      },
    ],
  },
  {
    title: "Safety & Security Features",
    lobCode: "FO",
    checkboxList: [
      {
        label: "Update Safety & Security Features",
        featureCode: "lob_fo_policies_update_safety_security_features",
      },
    ],
  },
  {
    title: "Occupancy & Usage",
    lobCode: "FO",
    checkboxList: [
      {
        label: "Update Occupancy & Usage",
        featureCode: "lob_fo_policies_update_usage_and_occupancy",
      },
    ],
  },
];

export const PERMISSIONS = [
  {
    group: "Forms",
    items: [
      { key: "forms:add", label: "Add Forms" },
      { key: "forms:edit", label: "Edit Forms" },
      { key: "forms:delete", label: "Delete Forms" },
    ],
  },
  {
    group: "UI Configuration",
    items: [{ key: "ui-configuration:edit", label: "Edit UI Configuration" }],
  },
  {
    group: "Features",
    items: [
      { key: "features:view", label: "View Features" },
      { key: "features:edit", label: "Edit Features" },
    ],
  },
  {
    group: "Communication Templates",
    items: [
      { key: "communication-templates:create", label: "Create Templates" },
      { key: "communication-templates:view", label: "View Templates" },
      { key: "communication-templates:edit", label: "Edit Templates" },
      { key: "communication-templates:delete", label: "Delete Templates" },
    ],
  },
  {
    group: "Lookup",
    items: [
      { key: "lookup:add", label: "Add Lookup Value" },
      { key: "lookup:edit", label: "Edit Lookup Value" },
      { key: "lookup:delete", label: "Delete Lookup Value" },
    ],
  },
  {
    group: "Content Management",
    items: [
      { key: "content-management:create", label: "Create Content" },
      { key: "content-management:view", label: "View Content" },
      { key: "content-management:edit", label: "Edit Content" },
      { key: "content-management:delete", label: "Delete Content" },
    ],
  },
  {
    group: "User Management",
    items: [
      { key: "user-management:invite", label: "Invite Users" },
      { key: "user-management:edit-status", label: "Edit User Status" },
      { key: "user-management:reset-password", label: "Reset Password" },
    ],
  },
  {
    group: "Insure Assist Performance",
    items: [
      { key: "insure-assist-performance:view", label: "View Performance" },
    ],
  },
  {
    group: "Conversation Analysis",
    items: [
      { key: "conversation-analysis:view", label: "View Analysis" },
      { key: "conversation-analysis:analyze", label: "Analyze Conversations" },
    ],
  },
  {
    group: "Secret Keys",
    items: [{ key: "secret-Keys:edit", label: "Edit Secret Keys" }],
  },
  {
    group: "Login Reports",
    items: [
      { key: "login-reports:view", label: "View Login Reports" },
      { key: "login-reports:export", label: "Export Login Reports" },
    ],
  },
];
